import { Link } from "react-router-dom";

const entries = [
  {
    to: "/news",
    label: "娱乐资讯",
    desc: "热点动态一手掌握",
    icon: "ri-newspaper-line",
    image:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20newsroom%20desk%20with%20newspapers%20and%20coffee%20under%20soft%20amber%20light%2C%20editorial%20magazine%20mood%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=600&height=400&seq=home-cat-news&orientation=landscape",
  },
  {
    to: "/original",
    label: "趣味原创",
    desc: "原创内容轻松有趣",
    icon: "ri-quill-pen-line",
    image:
      "https://readdy.ai/api/search-image?query=creative%20handmade%20craft%20desk%20with%20paper%20and%20colorful%20tools%20in%20warm%20afternoon%20light%2C%20playful%20diy%20mood%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=600&height=400&seq=home-cat-original&orientation=landscape",
  },
  {
    to: "/video",
    label: "视频专区",
    desc: "多元视听短剧集锦",
    icon: "ri-play-circle-line",
    image:
      "https://readdy.ai/api/search-image?query=warm%20mini%20cinema%20screen%20with%20amber%20lights%20and%20soft%20seats%2C%20inviting%20viewing%20mood%2C%20editorial%20photography%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20composition&width=600&height=400&seq=home-cat-video&orientation=landscape",
  },
  {
    to: "/community",
    label: "互动社区",
    desc: "发帖聊天一起玩",
    icon: "ri-chat-smile-2-line",
    image:
      "https://readdy.ai/api/search-image?query=friendly%20community%20gathering%20table%20with%20warm%20string%20lights%20and%20chat%20bubbles%2C%20welcoming%20social%20mood%2C%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20composition&width=600&height=400&seq=home-cat-community&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-3 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
        >
          <div className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-background-200">
            <img
              src={entry.image}
              alt={entry.label}
              title={`${entry.label} - 我爱搞`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                <i className={`${entry.icon} text-base`}></i>
              </span>
              <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                {entry.label}
              </h3>
            </div>
            <p className="mt-1 truncate text-xs text-foreground-500">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}